import { BlockIdentifier, BlockNoteEditor } from '@blocknote/core';
import { BlockSchema } from '../schema';

export default function ensureParagraphAfterBlockAndFocus(
  editor: BlockNoteEditor<BlockSchema>,
  blockIdentifier: BlockIdentifier,
) {
  if (!editor.domElement) {
    return;
  }

  const resolvedBlock =
    typeof blockIdentifier === 'string'
      ? editor.getBlock(blockIdentifier)
      : editor.getBlock(blockIdentifier.id);

  if (!resolvedBlock) {
    return;
  }

  const [paragraphBlock] = editor.insertBlocks(
    [{ type: 'paragraph' }],
    resolvedBlock,
    'after',
  );
  editor.setTextCursorPosition(paragraphBlock, 'start');
  editor.focus();
}
